import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule, NgbPopoverModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { CmsConfig, ConfigModule, I18nModule } from "@spartacus/core";
import { CustomUserRegistrationModule } from "src/app/custom-user-registration/custom-user-registration.module";
import { TermsConditionsModule } from "../terms-conditions/terms-conditions.module";
import { TermsConditionsComponent } from "../terms-conditions/terms-conditions/terms-conditions.component";
import { CheckoutComponent } from "./checkout.component";

@NgModule({
  declarations: [
    CheckoutComponent,


  ],
  exports: [
    CheckoutComponent,
  ],

  imports: [
    CommonModule,
    NgbTooltipModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    CustomUserRegistrationModule,
    I18nModule,
    NgbPopoverModule,
    NgbModule,
    TermsConditionsModule,
    ConfigModule.withConfig({

      cmsComponents: {
        checkoutPage: {

          component: TermsConditionsComponent
        }
      } } as CmsConfig),
  ],
  providers: [
  ],

})
export class CheckoutModule { }
